import { Button } from '@successmode-ktp/kui';
import styled from 'styled-components';
import ICON_24 from '@/assets/korUploadFile/icon_24.png';
import ICON_KAKAO from '@/assets/korUploadFile/icon_kakao.png';
import { useEffect, useState } from 'react';

type Props = {
  onChange: (v: 'KAKAO' | 'GOV') => void;
};

const Tab = ({ onChange }: Props) => {
  const [value, setValues] = useState<'KAKAO' | 'GOV'>('KAKAO');

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <Wrapper>
      <Button
        type='button'
        variant={value === 'KAKAO' ? 'line' : 'solid'}
        style={{
          backgroundColor: value === 'KAKAO' ? '#fff' : 'transparent',
          color: value === 'KAKAO' ? '#5089F8' : '#777777',
          fontSize: '14px',
          gap: '6px',
        }}
        onClick={() => setValues('KAKAO')}
      >
        <img src={ICON_KAKAO} alt='' width={17} />
        카카오톡 전자증명서
      </Button>
      <Button
        type='button'
        variant={value === 'GOV' ? 'line' : 'solid'}
        style={{
          backgroundColor: value === 'GOV' ? '#fff' : 'transparent',
          color: value === 'GOV' ? '#5089F8' : '#777777',
          fontSize: '14px',
          gap: '6px',
        }}
        onClick={() => setValues('GOV')}
      >
        <img src={ICON_24} alt='' width={17} />
        정부 24 발급
      </Button>
    </Wrapper>
  );
};
export default Tab;

const Wrapper = styled.div`
  display: flex;
  gap: 6px;
  padding: 6px;
  border-radius: 12px;
  background: var(--KTP-Grayscale-Gray_12, #f4f4f4);
`;
